<template>
    <div>
        <div class="field is-horizontal">
            <div class="field-label">
                <label class="label">ประธานโครงการ</label>
            </div>
            <div class="field-body is-block is-flex-widescreen">
                <div class="flex-grow">
                    <div v-for="(president, index) in project.presidents"
                         v-if="president.is_president"
                         :key="index"
                         class="flex mb-1"
                    >
                        <div class="flex-1 mr-1">
                            <v-select class="is-fullwidth"
                                      label="full_name"
                                      :options="people"
                                      :value="president.title"
                                      @input="(value) => changeMember(president, value)"
                                      placeholder="ระบุชื่อรองประธานโครงการ..."
                                      required
                                      taggable
                                      :filterable="false"
                                      @search="searchPeople"
                            >
                                <p slot="no-options">พิมพ์ชื่อบุคลากร มศว เพื่อค้นหา...</p>
                            </v-select>
                            <input type="hidden"
                                   :name="'presidents[' + (index+ 1) + '][id]'"
                                   v-model="president.id"
                            />
                            <input type="hidden"
                                   :name="'presidents[' + (index+ 1) + '][title]'"
                                   v-model="president.title"
                            />
                            <input type="hidden"
                                   :name="'presidents[' + (index+ 1) + '][person_id]'"
                                   v-model="president.person_id"
                            />
                        </div>
                        <div class="flex-1 flex items-center">
                            <input class="input mr-1"
                                   placeholder="ตำแหน่ง"
                                   :name="'presidents[' + (index+ 1) + '][position]'"
                                   v-model="president.position"
                            />
                            <input type="hidden"
                                   :name="'presidents[' + (index + 1) + '][is_president]'"
                                   :value="president.is_president ? 1: 0"
                            />
                            <input type="hidden"
                                   :name="'presidents[' + (index + 1) + '][is_vice_president]'"
                                   :value="president.is_vice_president ? 1: 0"
                            />
                            <div class="delete mr-1"
                                 @click.prevent="deleteMember('presidents', index)"
                            ></div>
                        </div>
                    </div>
                </div>
                <button type="button" class="button is-300"
                        @click.prevent="addPresident"
                        :disabled="president != null"
                >
                    เพิ่มประธาน
                </button>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label">
                <label class="label">รองประธาน</label>
            </div>
            <div class="field-body is-block is-flex-widescreen">
                <div class="flex-grow">
                    <div v-for="(president, index) in project.presidents"
                         v-if="president.is_vice_president"
                         :key="index"
                         class="flex mb-1"
                    >
                        <div class="flex-1 mr-1">
                            <v-select class="is-fullwidth"
                                      label="full_name"
                                      :options="people"
                                      :value="president.title"
                                      @input="(value) => changeMember(president, value)"
                                      placeholder="ระบุชื่อรองประธานโครงการ..."
                                      required
                                      taggable
                                      :filterable="false"
                                      @search="searchPeople"
                            >
                                <p slot="no-options">พิมพ์ชื่อบุคลากร มศว เพื่อค้นหา...</p>
                            </v-select>
                            <input type="hidden"
                                   :name="'presidents[' + (index+ 1) + '][id]'"
                                   v-model="president.id"
                            />
                            <input type="hidden"
                                   :name="'presidents[' + (index+ 1) + '][title]'"
                                   v-model="president.title"
                            />
                            <input type="hidden"
                                   :name="'presidents[' + (index+ 1) + '][person_id]'"
                                   v-model="president.person_id"
                            />
                        </div>
                        <div class="flex-1 flex items-center">
                            <input class="input mr-1"
                                   placeholder="ตำแหน่ง"
                                   :name="'presidents[' + (index+ 1) + '][position]'"
                                   v-model="president.position"
                            />
                            <input type="hidden"
                                   :name="'presidents[' + (index + 1) + '][is_president]'"
                                   :value="president.is_president ? 1: 0"
                            />
                            <input type="hidden"
                                   :name="'presidents[' + (index + 1) + '][is_vice_president]'"
                                   :value="president.is_vice_president ? 1: 0"
                            />
                            <div class="delete mr-1"
                                 @click.prevent="deleteMember('presidents', index)"
                            ></div>
                        </div>
                    </div>
                </div>
                <button type="button" class="button is-300"
                        @click.prevent="addVicePresident"
                >
                    เพิ่มรองประธานโครงการ
                </button>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    export default {
        data() {
            return {
                people: [],
                newMember
            }
        },
        props: {
            project: {type: Object, required: true},
        },

        computed: {
            president() {
                return this.project.presidents.find((p) => p.is_president);
            },
        },
        methods: {
            addPresident() {
                this.addMember('presidents', {
                    is_president: true,
                    is_vice_president: false
                });
            },
            addVicePresident() {
                this.addMember('presidents', {
                    is_president: false,
                    is_vice_president: true
                });
            },
            addMember(type, attributes = {}) {
                this.project[type].push(_.extend({}, this.newMember, attributes));
            },

            deleteMember(type, index) {
                this.project[type].splice(index, 1);
            },
            changeMember(member, person) {
                if (member.title == person) {
                    return;
                }
                member.person_id = null;

                if (this.isInternalPerson(person)) {
                    member.person_id = person.person_id;
                } else {
                    member.title = person;
                    member.person_id = null;
                }
            },

            isInternalPerson(person) {
                return typeof person === 'object' && person != null;
            },

            searchPeople(search, loading) {
                loading(true);

                axios.get('api/people/?q=' + search).then((resp) => {
                    this.people = resp.data;
                    loading(false);
                });
            },
        }
    }
</script>